import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Button, ButtonGroup, Content, Footer, Heading, Modal } from "@hopper-ui/components";
import { useCallback } from "react";

interface Props {
    isOpen: boolean;
    conversationTitle: string;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteConversationModal = ({ isOpen, conversationTitle, onClose, onConfirm }: Props) => {
    const { tShared } = useSharedTranslation();

    const handleOpenChange = useCallback((_isOpen: boolean) => {
        if (!_isOpen) {
            onClose();
        }
    }, [onClose]);

    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={handleOpenChange}
            size="sm"
        >
            <Heading>
                {tShared("deleteConversationModal.title")}
            </Heading>
            <Content>
                {tShared("deleteConversationModal.description", { conversationTitle })}
            </Content>
            <Footer>
                <ButtonGroup UNSAFE_width="100%">
                    <Button
                        variant="secondary"
                        onPress={onClose}
                        flexGrow={1}
                    >
                        {tShared("deleteConversationModal.cancel")}
                    </Button>
                    <Button
                        variant="danger"
                        onPress={onConfirm}
                        flexGrow={1}
                    >
                        {tShared("deleteConversationModal.delete")}
                    </Button>
                </ButtonGroup>
            </Footer>
        </Modal>
    );
};
